import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import baseTheme from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    Scroll?: InjectableCss;
    right?: InjectableCss;
}

export const viewStyles: ProductDetailsViewStyles = {
    leftColumnGridItem: {
        width: [12, 12, 12, 8, 9],
        css: css`
            overflow: hidden;
            direction: ltr;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 10px 10px 10px;
                    `,
                    css`
                        padding: 0 10px 10px 10px;
                    `,
                    css`
                        padding: 0 10px 10px 10px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    topGridItem: {
        width: [12, 12, 12, 6, 6],
    },

    middleGridItem: { width: [12, 12, 0, 0, 0] },
    middleGridItemHidden: {
        above: "sm",
        css: css`
            width: 100%;
            direction: ltr;
        `,
    },
    bottomGridItem: {
        width: [12, 12, 12, 6, 6],
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 4, 3],
        css: css`
            align-self: start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0 0 10px 0;
                    `,
                    css`
                        padding: 0 0 20px 0;
                    `,
                    css`
                        padding: 0 0 20px 0;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    rightColumnGridItemHidden: {
        // below: "md",
        css: css`
            width: 100%;
            direction: ltr;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    container: {
        offsetCss: css`
            display: flex;
            align-items: center;
        `,
    },
    right: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 0 auto;
                    `,
                    css`
                        margin: 0 auto;
                    `,
                    css`
                        margin: 0 auto;
                    `,
                    null,
                    null,
                ])};
        `,
    },
};

const styles = viewStyles;

const Wrapper = styled.div<{ active: boolean; isMobileDevice: boolean }>`
    flex: 1 1 0%;
    margin: 0px auto;
    position: relative;
    -webkit-box-pack: justify;
    justify-content: space-between;
    background-color: white;
    width: 100%;
    z-index: 999;
    min-height: ${(props: any) => (props.isMobileDevice ? "160px" : props.active ? "110px" : "auto")};
    max-width: 1200px;
    padding: 10px 0;
    left: 0;
    display: flex;
    .stickyImage {
        align-self: flex-start;
    }
    .stickyImage {
        align-self: flex-start;
    }
    ${props =>
        props.active
            ? `
            display: flex;
            justify-content: center;
            align-items: center;
            div[class^="GridWrapper"] {
                margin: 0 16px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 160px;
                    `,
                    css`
                        height: 160px;
                    `,
                    css`
                        height: 160px;
                    `,
                    null,
                    null,
                ])};
            .stickyImage {
                width: 100%;
                flex-basis: 30%;
                max-width: 30%;
                display: ${(props: any) => (props.isMobileDevice ? "none" : "block")};
            }
            .attributes {
                width: 100%;
                flex-basis: 70%;
                max-width: 70%;
                div [data-test-selector^="productDetails_attributes"] {
                    display: none;
                }
                div [data-test-selector^="productDetails_htmlContent"] {
                    display: none;
                }
                span[data-test-selector^="productDetails_productDescription"] {
                    transform: translateY(50%);
                }
                div[class^="GridItemStyle"] {
                    > span[class^="TypographyStyle"] {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            div[class^="GridItemStyle"] {
                                display: flex;
                                justify-content: center;
                            }
                        `,
                        css`
                            div[class^="GridItemStyle"] {
                                display: flex;
                                justify-content: center;
                            }
                        `,
                        css`
                            div[class^="GridItemStyle"] {
                                display: flex;
                                justify-content: center;
                            }
                        `,
                        null,
                        null,
                    ])};
            }
            .actionButton {
                width: 100%;
                flex-basis: 50%;
                max-width: 50%;
                justify-content:end;
            }
            .imagecontainer {
                width: 100%;
                flex-basis: 50%;
                max-width: 50%;
                div[class^="GridWrapper"] {
                    margin: 0 !important;
                }
            }
            .buttonAction {
                display: flex;
                flex-direction: row;
                gap: 40px;
            }`
            : `${(props: any) =>
                  props.isMobileDevice
                      ? `.attributes {
        width: 100%;
        flex-basis: 70%;
        max-width: 70%;
        div [data-test-selector^="productDetails_attributes"] {
            display: none;
        }
        div [data-test-selector^="productDetails_htmlContent"] {
            display: none;
        }
        span[data-test-selector^="productDetails_productDescription"] {
            transform: translateY(50%);
        }
    }`
                      : ""}`}
    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                .buttonAction {
                    display: flex;
                    flex-direction: row;
                    gap: 20px;
                }
                .imagecontainer {
                    flex-basis: 100%;
                    max-width: 100%;
                }
                .actionButton {
                    flex-basis: 100%;
                    max-width: 100%;
                }
                .attributes {
                    div [data-test-selector^="productDetails_attributes"] {
                        display: none;
                    }
                    div[class^="Wrapper"] {
                        div[class^="GridWrapper"] {
                            margin: 0;
                            div[class^="GridOffset"] {
                                div[class^="GridItemStyle"] {
                                    justify-content: center;
                                    text-align: center;
                                }
                            }
                        }
                    }
                    span[data-test-selector^="productDetails_productDescription"] {
                        text-align: center;
                    }
                    div[class^="GridItemStyle"] {
                        > span[class^="TypographyStyle"] {
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                        }
                    }
                }
                .stickyImage {
                    display: none;
                }
            `,
            css`
                transition: unset !important;
                height: auto !important;
                .buttonAction {
                    display: flex;
                    flex-direction: row;
                }
                .imagecontainer {
                    flex-basis: 100%;
                    max-width: 100%;
                    div[class^="GridOffset"] {
                        justify-content: center;
                    }
                }
                .actionButton {
                    flex-basis: 100%;
                    max-width: 100%;
                }
                .attributes {
                    display: none;
                    span[data-test-selector^="productDetails_productDescription"] {
                        text-align: center;
                    }
                }
                .stickyImage {
                    display: none;
                }
            `,
            null,
            null,
            null,
        ]);
    }}
`;

const ProductDetailsView: React.FC<WidgetProps> = props => {
    const [offsetHeight, setOffsetHeight] = React.useState(0);
    const [offsetWidth, setOffsetWidth] = React.useState(0);

    React.useEffect(() => {
        window.onscroll = () => {
            setOffsetHeight(window.pageYOffset);
            setOffsetWidth(window.outerWidth);
        };
    }, []);

    const isApplyMobileDevice = offsetWidth < 992;

    const leftColumnInnerContainer = {
        offsetCss: css`
            display: flex;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    };
    // const id: any = document.getElementById('mainContainer-id');
    const isActive = window.scrollY > 0;
    // const mainId = document.getElementsByTagName('main');
    // const clientHeight = mainId[0].clientHeight < 800;
    const containerWrapper = {
        css: css`
            position: ${window.scrollY > 0 ? "fixed" : "relative"};
            top: 0;
            display: flex;
            left: 0;
            width: 100%;
            z-index: 11;
            background: white;
        `,
    };
    return (
        <StyledWrapper id="mainContainer-id" {...containerWrapper}>
            <Wrapper className="mainContainer" active={isActive} isMobileDevice={isApplyMobileDevice}>
                <GridContainer {...styles.container}>
                    <GridItem
                        {...styles.leftColumnGridItem}
                        className="imagecontainer"
                        data-test-selector="productDetails_leftColumn"
                    >
                        <GridContainer {...leftColumnInnerContainer}>
                            <GridItem {...styles.topGridItem} className="stickyImage">
                                <Zone contentId={props.id} zoneName="Content0" />
                            </GridItem>
                            <GridItem {...styles.bottomGridItem} className="attributes">
                                <Zone contentId={props.id} zoneName="Content2" />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem
                        {...styles.rightColumnGridItem}
                        className="actionButton"
                        data-test-selector="productDetails_rightColumn"
                    >
                        <StyledWrapper {...styles.right}>
                            <Hidden {...styles.rightColumnGridItemHidden}>
                                <Zone contentId={props.id} zoneName="Content3" />
                            </Hidden>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </Wrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
